// extracted by mini-css-extract-plugin
export var chip = "_5a-0";
export var filterDropdown = "_5a-5";
export var filterItem = "_5a-6";
export var icon = "_5a-1";
export var removeButton = "_5a-3";
export var removeIcon = "_5a-4";
export var separator = "_5a-2";